<dsy-card render-level="outer" has-border="true">
  <div class="filters">
    <div class="filters__fields">
      <div class="filters__field">
        @if (organizationFilterEntriesSignal().length > 0) {
          <fdr-past-performance-ui-searchable-dropdown
            [label]="'PD.LABELS.ORGANIZATION' | translate"
            [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
            [closesOnSelection]="false"
            [entries]="organizationFilterEntriesSignal()"
            [customDsyListConfObject]="dropdownListConfig"
          ></fdr-past-performance-ui-searchable-dropdown>
        } @else {
          <dsy-input-dropdown
            [label]="'PD.LABELS.ORGANIZATION' | translate"
            [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
            [isDisabled]="true"
            [entries]="[]"
          ></dsy-input-dropdown>
        }
      </div>
      <div class="filters__field">
        @if (siteFilterEntriesSignal().length > 0) {
          <fdr-past-performance-ui-searchable-dropdown
            [label]="'PD.LABELS.SITE' | translate"
            [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
            [closesOnSelection]="false"
            [entries]="siteFilterEntriesSignal()"
            [customDsyListConfObject]="dropdownListConfig"
          ></fdr-past-performance-ui-searchable-dropdown>
        } @else {
          <dsy-input-dropdown
            [label]="'PD.LABELS.SITE' | translate"
            [placeholder]="'PD.LABELS.SELECT_OPTION' | translate"
            [isDisabled]="true"
            [entries]="[]"
          ></dsy-input-dropdown>
        }
      </div>
    </div>

    <div class="filters__actions">
      <dsy-button class="filters__reset" variant="link" color="neutral" (click)="onReset()" [disabled]="resetButtonDisabledSignal()">
        {{ 'PD.BUTTONS.RESET_FILTERS' | translate }}
      </dsy-button>
      <dsy-divider class="filters__divider" divider-orientation="vertical" divider-color="light-grey"></dsy-divider>
      <dsy-button class="filters__apply" variant="primary" density="wide" fill (click)="onApply()" [disabled]="applyButtonDisabledSignal()">
        {{ 'PD.BUTTONS.APPLY' | translate }}
      </dsy-button>
    </div>
  </div>
</dsy-card>
